// import React, { useState } from "react";
// import styled from "styled-components";
// import { FaLock, FaUserEdit, FaBell, FaEye, FaEyeSlash } from "react-icons/fa";
// import Navbar from "./Navbar";
// import DashboardHeader from "./DashboardHeader";
// import Footer from "./Footer";
// import api from "../api"; 

// /* ================= PAGE LAYOUT & THEME (Matching Dashboard) ================= */
// const Container = styled.div`
//   --sidebar-expanded: 260px;
//   --sidebar-collapsed: 90px;
//   --page-bg: linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%);
//   --card-bg: rgba(255, 255, 255, 0.96);
//   --text-main: #0f172a;
//   --text-soft: #64748b;
//   --border: rgba(148, 163, 184, 0.18);
//   --primary: #2563eb;
//   --primary-dark: #1d4ed8;
//   --shadow-lg: 0 22px 55px rgba(15, 23, 42, 0.08);
//   --shadow-md: 0 12px 30px rgba(15, 23, 42, 0.06);

//   min-height: 100vh;
//   background: var(--page-bg);
//   margin-left: ${({ collapsed }) =>
//     collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
//   transition: margin-left 0.3s ease, background 0.3s ease;

//   @media (max-width: 1023px) { margin-left: 0; }
// `;

// const Main = styled.main`
//   width: min(1380px, calc(100% - 32px)); margin: 0 auto; padding: 94px 0 80px;
//   @media (max-width: 1023px) { width: min(100%, calc(100% - 24px)); padding-top: 86px; }
//   @media (max-width: 576px) { width: min(100%, calc(100% - 16px)); }
// `;

// /* ================= HERO ================= */
// const Hero = styled.section`
//   margin-bottom: 24px;
// `;

// const HeroPanel = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 45%, #2563eb 100%); color: white;
//   padding: 32px 28px; border-radius: 20px; box-shadow: var(--shadow-lg); position: relative;
//   overflow: hidden; display: flex; flex-direction: column; justify-content: flex-start;

//   &::before {
//     content: ""; position: absolute; right: -30px; bottom: -60px; width: 180px; height: 180px;
//     border-radius: 50%; background: rgba(255, 255, 255, 0.08);
//   }
//   @media (max-width: 576px) { padding: 24px 18px; border-radius: 16px; }
// `;

// const HeroTitle = styled.h1`
//   margin: 0; font-size: clamp(1.8rem, 1.5rem + 1.5vw, 2.5rem); line-height: 1.1; font-weight: 800; position: relative; z-index: 1;
// `;

// const HeroText = styled.p`
//   margin: 16px 0 0; color: rgba(255, 255, 255, 0.82); line-height: 1.5; font-size: 0.95rem; max-width: 720px; position: relative; z-index: 1;
// `;

// /* ================= CARDS / FORMS ================= */
// const SettingsGrid = styled.div`
//   display: grid;
//   grid-template-columns: 1fr;
//   gap: 24px;
//   max-width: 800px; 
// `;

// const Card = styled.div`
//   background: var(--card-bg); border-radius: 28px; padding: 30px; box-shadow: var(--shadow-md); border: 1px solid var(--border);
//   @media (max-width: 768px) { padding: 20px; border-radius: 22px; }
// `;

// const TitleRow = styled.div`
//   display: flex; align-items: center; gap: 12px; margin-bottom: 8px;
// `;

// const IconWrap = styled.div`
//   color: var(--primary);
//   font-size: 1.4rem;
//   display: flex;
//   align-items: center;
// `;

// const SectionTitle = styled.h2`
//   font-size: clamp(1.15rem, 1rem + 0.6vw, 1.35rem); color: #1f2937; margin: 0; font-weight: 800;
// `;

// const Subtitle = styled.p` color: #6b7280; margin: 0 0 24px; font-size: 0.95rem; line-height: 1.6; `;

// const Form = styled.form` display: flex; flex-direction: column; gap: 20px; `;

// const FormGrid = styled.div`
//   display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px;
//   @media (max-width: 768px) { grid-template-columns: 1fr; }
// `;

// const FormGroup = styled.div` display: flex; flex-direction: column; gap: 8px; `;
// const Label = styled.label` font-size: 14px; font-weight: 700; color: #374151; `;

// const Input = styled.input`
//   width: 100%;
//   padding: 14px 16px; border-radius: 12px; border: 1px solid #e5e7eb; font-size: 15px; background: white;
//   transition: all 0.2s ease;
//   box-sizing: border-box;
//   &:focus { border-color: #2563eb; box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12); outline: none; }
//   &:disabled { background: #f8fafc; color: #94a3b8; cursor: not-allowed; }
// `;

// /* ===== PASSWORD INPUT WRAPPER ===== */
// const PasswordInputWrapper = styled.div`
//   position: relative;
//   display: flex;
//   align-items: center;
// `;

// const PasswordInput = styled(Input)`
//   padding-right: 48px; /* Make room for the eye icon */

//   /* Hide the native browser password reveal icon (especially in Edge) */
//   &::-ms-reveal,
//   &::-ms-clear {
//     display: none;
//   }
// `;

// const EyeButton = styled.button`
//   position: absolute;
//   right: 14px;
//   background: none;
//   border: none;
//   color: #94a3b8;
//   font-size: 18px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding: 0;
//   transition: color 0.2s ease;

//   &:hover {
//     color: #3b82f6;
//   }
// `;

// const FormActions = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   margin-top: 10px;
// `;

// const Button = styled.button`
//   appearance: none; padding: 14px 24px; background: linear-gradient(135deg, #2563eb, #3b82f6); color: white;
//   border: none; border-radius: 12px; font-size: 15px; font-weight: 700; cursor: pointer; min-width: 140px;
//   box-shadow: 0 10px 20px rgba(37, 99, 235, 0.18); transition: transform 0.2s ease, box-shadow 0.2s ease;
//   &:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 14px 24px rgba(37, 99, 235, 0.24); }
//   &:disabled { background: linear-gradient(135deg, #93c5fd, #bfdbfe); cursor: not-allowed; box-shadow: none; }
// `;

// const Message = styled.div`
//   padding: 14px 18px; border-radius: 12px; margin-bottom: 20px; font-size: 14.5px; font-weight: 500;
//   ${({ type }) => type === "success" ? `background: #ecfdf5; color: #10b981; border: 1px solid #a7f3d0;` : `background: #fef2f2; color: #ef4444; border: 1px solid #fecaca;`}
// `;

// /* Toggle Switch Styles */
// const ToggleLabel = styled.label`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   cursor: pointer;
//   padding: 12px 16px;
//   border: 1px solid #e2e8f0;
//   border-radius: 12px;
//   transition: background 0.2s;
//   &:hover { background: #f8fafc; }
// `;

// const ToggleText = styled.div`
//   font-size: 14.5px; font-weight: 600; color: #334155;
// `;

// const ToggleSubtext = styled.div`
//   font-size: 12.5px; font-weight: 400; color: #64748b; margin-top: 2px;
// `;

// const Switch = styled.div`
//   position: relative; width: 44px; height: 24px; background: ${({ active }) => (active ? "#2563eb" : "#cbd5e1")};
//   border-radius: 999px; transition: background 0.3s ease;
//   &::after {
//     content: ""; position: absolute; top: 2px; left: ${({ active }) => (active ? "22px" : "2px")};
//     width: 20px; height: 20px; background: white; border-radius: 50%; transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//     box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//   }
// `;

// /* ================= COMPONENT ================= */
// const Settings = ({ user }) => {
//   const [collapsed, setCollapsed] = useState(false);

//   // States for Profile Update
//   const [profileData, setProfileData] = useState({
//     username: user?.username || user?.name || "",
//     email: user?.email || "",
//   });
//   const [profileLoading, setProfileLoading] = useState(false);
//   const [profileMsg, setProfileMsg] = useState({ type: "", text: "" });

//   // States for Password Update
//   const [passwordData, setPasswordData] = useState({
//     currentPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//   });
//   const [passwordLoading, setPasswordLoading] = useState(false);
//   const [passwordMsg, setPasswordMsg] = useState({ type: "", text: "" });

//   // Password Visibility States
//   const [showCurrentPassword, setShowCurrentPassword] = useState(false);
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//   // States for Notifications
//   const [notifications, setNotifications] = useState({
//     emailAlerts: true,
//     weeklyDigest: false,
//   });

//   const handleProfileChange = (e) => {
//     setProfileData({ ...profileData, [e.target.name]: e.target.value });
//     setProfileMsg({ type: "", text: "" });
//   };

//   const handlePasswordChange = (e) => {
//     setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
//     setPasswordMsg({ type: "", text: "" });
//   };

//   const toggleNotification = (key) => {
//     setNotifications((prev) => ({ ...prev, [key]: !prev[key] }));
//   };

//   const handleProfileSubmit = async (e) => {
//     e.preventDefault();
//     setProfileLoading(true);
//     try {
//       // Example API call:
//       // await api.put('/user/profile', profileData);
      
//       await new Promise((resolve) => setTimeout(resolve, 1000));
//       setProfileMsg({ type: "success", text: "Profile information updated successfully." });
//     } catch (err) {
//       setProfileMsg({ type: "error", text: err.response?.data?.message || "Failed to update profile." });
//     } finally {
//       setProfileLoading(false);
//     }
//   };
//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     setPasswordLoading(true);

//     if (passwordData.newPassword !== passwordData.confirmPassword) {
//       setPasswordMsg({ type: "error", text: "New passwords do not match." });
//       setPasswordLoading(false);
//       return;
//     }

//     // <-- The 8-character check was completely deleted from here

//     try {
//       // Example API call:
//       // await api.put('/auth/change-password', {
//       //   oldPassword: passwordData.currentPassword,
//       //   newPassword: passwordData.newPassword
//       // });

//       await new Promise((resolve) => setTimeout(resolve, 1000));
//       setPasswordMsg({ type: "success", text: "Password changed successfully." });
//       setPasswordData({ currentPassword: "", newPassword: "", confirmPassword: "" });
      
//       // Reset visibility when successful
//       setShowCurrentPassword(false);
//       setShowNewPassword(false);
//       setShowConfirmPassword(false);
//     } catch (err) {
//       setPasswordMsg({ type: "error", text: err.response?.data?.message || "Failed to change password." });
//     } finally {
//       setPasswordLoading(false);
//     }
//   };

//   return (
//     <Container collapsed={collapsed}>
//       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//       <DashboardHeader user={user} collapsed={collapsed} title="Settings" />

//       <Main>
//         <Hero>
//           <HeroPanel>
//             <HeroTitle>Settings</HeroTitle>
//             <HeroText>Manage your account preferences, profile details, and security.</HeroText>
//           </HeroPanel>
//         </Hero>

//         <SettingsGrid>
          
//           {/* PROFILE INFORMATION CARD */}
//           <Card>
//             <TitleRow>
//               <IconWrap><FaUserEdit /></IconWrap>
//               <SectionTitle>Profile Information</SectionTitle>
//             </TitleRow>
//             <Subtitle>Update your account details and how you are recognized in the system.</Subtitle>
            
//             {profileMsg.text && <Message type={profileMsg.type}>{profileMsg.text}</Message>}

//             <Form onSubmit={handleProfileSubmit}>
//               <FormGrid>
//                 <FormGroup>
//                   <Label>Username</Label>
//                   <Input 
//                     type="text" 
//                     name="username" 
//                     value={profileData.username} 
//                     onChange={handleProfileChange} 
//                     required 
//                   />
//                 </FormGroup>
//                 <FormGroup>
//                   <Label>Email Address</Label>
//                   <Input 
//                     type="email" 
//                     name="email" 
//                     value={profileData.email} 
//                     onChange={handleProfileChange} 
//                     required 
//                   />
//                 </FormGroup>
//               </FormGrid>
//               <FormGroup>
//                 <Label>Role / Title</Label>
//                 <Input 
//                   type="text" 
//                   value={user?.role || "Staff"} 
//                   disabled 
//                   title="Contact an administrator to change your role"
//                 />
//               </FormGroup>

//               <FormActions>
//                 <Button type="submit" disabled={profileLoading}>
//                   {profileLoading ? "Saving..." : "Save Changes"}
//                 </Button>
//               </FormActions>
//             </Form>
//           </Card>

//           {/* CHANGE PASSWORD CARD */}
//           <Card>
//             <TitleRow>
//               <IconWrap><FaLock /></IconWrap>
//               <SectionTitle>Change Password</SectionTitle>
//             </TitleRow>
//             <Subtitle>Ensure your account is using a long, random password to stay secure.</Subtitle>

//             {passwordMsg.text && <Message type={passwordMsg.type}>{passwordMsg.text}</Message>}

//             <Form onSubmit={handlePasswordSubmit}>
            
//               <FormGrid>
//                 <FormGroup>
//                   <Label>New Password</Label>
//                   <PasswordInputWrapper>
//                     <PasswordInput 
//                       type={showNewPassword ? "text" : "password"} 
//                       name="newPassword" 
//                       value={passwordData.newPassword} 
//                       onChange={handlePasswordChange} 
//                       placeholder=" Enter new password"
//                       required 
//                     />
//                     <EyeButton type="button" onClick={() => setShowNewPassword(!showNewPassword)}>
//                       {showNewPassword ? <FaEyeSlash /> : <FaEye />}
//                     </EyeButton>
//                   </PasswordInputWrapper>
//                 </FormGroup>
                
//                 <FormGroup>
//                   <Label>Confirm New Password</Label>
//                   <PasswordInputWrapper>
//                     <PasswordInput 
//                       type={showConfirmPassword ? "text" : "password"} 
//                       name="confirmPassword" 
//                       value={passwordData.confirmPassword} 
//                       onChange={handlePasswordChange} 
//                       placeholder="Confirm new password"
//                       required 
//                     />
//                     <EyeButton type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
//                       {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//                     </EyeButton>
//                   </PasswordInputWrapper>
//                 </FormGroup>
//               </FormGrid>

//               <FormActions>
//                 <Button type="submit" disabled={passwordLoading}>
//                   {passwordLoading ? "Updating..." : "Update Password"}
//                 </Button>
//               </FormActions>
//             </Form>
//           </Card>
//         </SettingsGrid>
//       </Main>
//       <Footer />
//     </Container>
//   );
// };

// export default Settings;





// import React, { useState, useEffect } from "react";
// import styled from "styled-components";
// import { FaLock, FaUserEdit, FaBell, FaEye, FaEyeSlash, FaMoon, FaSun } from "react-icons/fa";
// import Navbar from "./Navbar";
// import DashboardHeader from "./DashboardHeader";
// import Footer from "./Footer";
// import api from "../api"; 
// import { useTheme } from '../App';
// /* ================= PAGE LAYOUT & THEME ================= */
// // Notice how the CSS variables change based on the $isDarkMode prop
// const Container = styled.div`
//   --sidebar-expanded: 260px;
//   --sidebar-collapsed: 90px;
  
//   /* Theme Variables */
//   --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
//   --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
//   --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
//   --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
//   --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
//   --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
//   --input-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e5e7eb'};
  
//   --primary: #2563eb;
//   --primary-dark: #1d4ed8;
//   --shadow-lg: 0 22px 55px rgba(0, 0, 0, 0.15);
//   --shadow-md: 0 12px 30px rgba(0, 0, 0, 0.1);

//   min-height: 100vh;
//   background: var(--page-bg);
//   color: var(--text-main);
//   margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
//   transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

//   @media (max-width: 1023px) { margin-left: 0; }
// `;

// const Main = styled.main`
//   width: min(1380px, calc(100% - 32px)); margin: 0 auto; padding: 94px 0 80px;
//   @media (max-width: 1023px) { width: min(100%, calc(100% - 24px)); padding-top: 86px; }
//   @media (max-width: 576px) { width: min(100%, calc(100% - 16px)); }
// `;

// /* ================= HERO ================= */
// const Hero = styled.section` margin-bottom: 24px; `;

// const HeroPanel = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 45%, #2563eb 100%); color: white;
//   padding: 32px 28px; border-radius: 20px; box-shadow: var(--shadow-lg); position: relative;
//   overflow: hidden; display: flex; flex-direction: column; justify-content: flex-start;

//   &::before {
//     content: ""; position: absolute; right: -30px; bottom: -60px; width: 180px; height: 180px;
//     border-radius: 50%; background: rgba(255, 255, 255, 0.08);
//   }
//   @media (max-width: 576px) { padding: 24px 18px; border-radius: 16px; }
// `;

// const HeroTitle = styled.h1` margin: 0; font-size: clamp(1.8rem, 1.5rem + 1.5vw, 2.5rem); line-height: 1.1; font-weight: 800; position: relative; z-index: 1; `;
// const HeroText = styled.p` margin: 16px 0 0; color: rgba(255, 255, 255, 0.82); line-height: 1.5; font-size: 0.95rem; max-width: 720px; position: relative; z-index: 1; `;

// /* ================= CARDS / FORMS ================= */
// const SettingsGrid = styled.div`
//   display: grid; grid-template-columns: 1fr; gap: 24px; max-width: 800px; 
// `;

// const Card = styled.div`
//   background: var(--card-bg); border-radius: 28px; padding: 30px; box-shadow: var(--shadow-md); border: 1px solid var(--border);
//   transition: background 0.3s ease, border 0.3s ease;
//   @media (max-width: 768px) { padding: 20px; border-radius: 22px; }
// `;

// const TitleRow = styled.div` display: flex; align-items: center; gap: 12px; margin-bottom: 8px; `;

// const IconWrap = styled.div` color: var(--primary); font-size: 1.4rem; display: flex; align-items: center; `;

// const SectionTitle = styled.h2` font-size: clamp(1.15rem, 1rem + 0.6vw, 1.35rem); color: var(--text-main); margin: 0; font-weight: 800; `;

// const Subtitle = styled.p` color: var(--text-soft); margin: 0 0 24px; font-size: 0.95rem; line-height: 1.6; `;

// const Form = styled.form` display: flex; flex-direction: column; gap: 20px; `;

// const FormGrid = styled.div` display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; @media (max-width: 768px) { grid-template-columns: 1fr; } `;

// const FormGroup = styled.div` display: flex; flex-direction: column; gap: 8px; `;
// const Label = styled.label` font-size: 14px; font-weight: 700; color: var(--text-main); `;

// const Input = styled.input`
//   width: 100%;
//   padding: 14px 16px; border-radius: 12px; border: 1px solid var(--input-border); 
//   font-size: 15px; background: var(--input-bg); color: var(--text-main);
//   transition: all 0.2s ease; box-sizing: border-box;
//   &:focus { border-color: #2563eb; box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12); outline: none; }
//   &:disabled { background: var(--border); color: var(--text-soft); cursor: not-allowed; }
// `;

// /* ===== PASSWORD INPUT WRAPPER ===== */
// const PasswordInputWrapper = styled.div` position: relative; display: flex; align-items: center; `;
// const PasswordInput = styled(Input)` padding-right: 48px; &::-ms-reveal, &::-ms-clear { display: none; } `;
// const EyeButton = styled.button` position: absolute; right: 14px; background: none; border: none; color: #94a3b8; font-size: 18px; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0; transition: color 0.2s ease; &:hover { color: #3b82f6; } `;

// const FormActions = styled.div` display: flex; justify-content: flex-end; margin-top: 10px; `;

// const Button = styled.button`
//   appearance: none; padding: 14px 24px; background: linear-gradient(135deg, #2563eb, #3b82f6); color: white;
//   border: none; border-radius: 12px; font-size: 15px; font-weight: 700; cursor: pointer; min-width: 140px;
//   box-shadow: 0 10px 20px rgba(37, 99, 235, 0.18); transition: transform 0.2s ease, box-shadow 0.2s ease;
//   &:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 14px 24px rgba(37, 99, 235, 0.24); }
//   &:disabled { background: linear-gradient(135deg, #93c5fd, #bfdbfe); cursor: not-allowed; box-shadow: none; }
// `;

// const Message = styled.div`
//   padding: 14px 18px; border-radius: 12px; margin-bottom: 20px; font-size: 14.5px; font-weight: 500;
//   ${({ type, $isDarkMode }) => {
//     if (type === "success") return $isDarkMode ? `background: rgba(16, 185, 129, 0.1); color: #34d399; border: 1px solid rgba(52, 211, 153, 0.3);` : `background: #ecfdf5; color: #10b981; border: 1px solid #a7f3d0;`;
//     return $isDarkMode ? `background: rgba(239, 68, 68, 0.1); color: #f87171; border: 1px solid rgba(248, 113, 113, 0.3);` : `background: #fef2f2; color: #ef4444; border: 1px solid #fecaca;`;
//   }}
// `;

// /* Toggle Switch Styles */
// const ToggleLabel = styled.label`
//   display: flex; align-items: center; justify-content: space-between; cursor: pointer;
//   padding: 16px; border: 1px solid var(--border); border-radius: 16px;
//   background: var(--input-bg); transition: background 0.2s;
//   &:hover { border-color: #94a3b8; }
// `;

// const ToggleInfo = styled.div` display: flex; align-items: center; gap: 14px; `;
// const ToggleIconWrap = styled.div` font-size: 1.4rem; color: ${({ active }) => active ? '#fbbf24' : '#64748b'}; display: flex; `;
// const ToggleTextWrap = styled.div` display: flex; flex-direction: column; `;
// const ToggleText = styled.div` font-size: 15px; font-weight: 700; color: var(--text-main); `;
// const ToggleSubtext = styled.div` font-size: 13px; font-weight: 400; color: var(--text-soft); margin-top: 2px; `;

// const Switch = styled.div`
//   position: relative; width: 48px; height: 26px; background: ${({ active }) => (active ? "#2563eb" : "#cbd5e1")};
//   border-radius: 999px; transition: background 0.3s ease; flex-shrink: 0;
//   &::after {
//     content: ""; position: absolute; top: 3px; left: ${({ active }) => (active ? "25px" : "3px")};
//     width: 20px; height: 20px; background: white; border-radius: 50%; transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//     box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//   }
// `;


// /* ================= COMPONENT ================= */
// const Settings = ({ user }) => {
//   const [collapsed, setCollapsed] = useState(false);

//   // Initialize Dark Mode state from localStorage, default to false
//   // const [isDarkMode, setIsDarkMode] = useState(() => {
//   //   return localStorage.getItem("appTheme") === "dark";
//   // });
//   const { isDarkMode, toggleTheme } = useTheme();

//   // Toggle Dark Mode handler
//   // const handleThemeToggle = () => {
//   //   setIsDarkMode((prev) => {
//   //     const newTheme = !prev;
//   //     localStorage.setItem("appTheme", newTheme ? "dark" : "light");
//   //     return newTheme;
//   //   });
//   // };

//   // States for Profile Update
//   const [profileData, setProfileData] = useState({
//     username: user?.username || user?.name || "",
//     email: user?.email || "",
//   });
//   const [profileLoading, setProfileLoading] = useState(false);
//   const [profileMsg, setProfileMsg] = useState({ type: "", text: "" });

//   // States for Password Update
//   const [passwordData, setPasswordData] = useState({
//     newPassword: "",
//     confirmPassword: "",
//   });
//   const [passwordLoading, setPasswordLoading] = useState(false);
//   const [passwordMsg, setPasswordMsg] = useState({ type: "", text: "" });

//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//   const handleProfileChange = (e) => {
//     setProfileData({ ...profileData, [e.target.name]: e.target.value });
//     setProfileMsg({ type: "", text: "" });
//   };

//   const handlePasswordChange = (e) => {
//     setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
//     setPasswordMsg({ type: "", text: "" });
//   };

//   const handleProfileSubmit = async (e) => {
//     e.preventDefault();
//     setProfileLoading(true);
//     try {
//       // Connects to your existing backend profile route
//       await api.put('/auth/profile', { email: profileData.email });
//       setProfileMsg({ type: "success", text: "Email updated successfully." });
//     } catch (err) {
//       setProfileMsg({ type: "error", text: err.response?.data?.message || "Failed to update profile." });
//     } finally {
//       setProfileLoading(false);
//     }
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     setPasswordLoading(true);

//     if (passwordData.newPassword !== passwordData.confirmPassword) {
//       setPasswordMsg({ type: "error", text: "New passwords do not match." });
//       setPasswordLoading(false);
//       return;
//     }

//     try {
//       // Connects to the new backend password route
//       await api.put('/auth/change-password', {
//         newPassword: passwordData.newPassword
//       });

//       setPasswordMsg({ type: "success", text: "Password changed successfully." });
//       setPasswordData({ newPassword: "", confirmPassword: "" });
//       setShowNewPassword(false);
//       setShowConfirmPassword(false);
//     } catch (err) {
//       setPasswordMsg({ type: "error", text: err.response?.data?.message || "Failed to change password." });
//     } finally {
//       setPasswordLoading(false);
//     }
//   };

//   return (
//     <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
//       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//       <DashboardHeader user={user} collapsed={collapsed} title="Settings" />

//       <Main>
//         <Hero>
//           <HeroPanel>
//             <HeroTitle>Settings</HeroTitle>
//             <HeroText>Manage your account preferences, profile details, and security.</HeroText>
//           </HeroPanel>
//         </Hero>

//         <SettingsGrid>
          
//           {/* THEME / PREFERENCES CARD */}
//           <Card>
//             <TitleRow>
//               <IconWrap><FaSun /></IconWrap>
//               <SectionTitle>Preferences</SectionTitle>
//             </TitleRow>
//             <Subtitle>Customize how the application looks for you.</Subtitle>

//             <ToggleLabel onClick={toggleTheme}>
//               <ToggleInfo>
//                 <ToggleIconWrap active={isDarkMode}>
//                   {isDarkMode ? <FaMoon /> : <FaSun />}
//                 </ToggleIconWrap>
//                 <ToggleTextWrap>
//                   <ToggleText>Dark Mode</ToggleText>
//                   <ToggleSubtext>Switch the interface to a darker color palette.</ToggleSubtext>
//                 </ToggleTextWrap>
//               </ToggleInfo>
//               <Switch active={isDarkMode} />
//             </ToggleLabel>
//           </Card>

//           {/* PROFILE INFORMATION CARD */}
//           <Card>
//             <TitleRow>
//               <IconWrap><FaUserEdit /></IconWrap>
//               <SectionTitle>Profile Information</SectionTitle>
//             </TitleRow>
//             <Subtitle>Update your account details and how you are recognized in the system.</Subtitle>
            
//             {profileMsg.text && <Message type={profileMsg.type} $isDarkMode={isDarkMode}>{profileMsg.text}</Message>}

//             <Form onSubmit={handleProfileSubmit}>
//               <FormGrid>
//                 <FormGroup>
//                   <Label>Username</Label>
//                   <Input 
//                     type="text" 
//                     name="username" 
//                     value={profileData.username} 
//                     disabled 
//                     title="Username cannot be changed"
//                   />
//                 </FormGroup>
//                 <FormGroup>
//                   <Label>Email Address</Label>
//                   <Input 
//                     type="email" 
//                     name="email" 
//                     value={profileData.email} 
//                     onChange={handleProfileChange} 
//                     required 
//                   />
//                 </FormGroup>
//               </FormGrid>

//               <FormActions>
//                 <Button type="submit" disabled={profileLoading}>
//                   {profileLoading ? "Saving..." : "Save Email"}
//                 </Button>
//               </FormActions>
//             </Form>
//           </Card>

//           {/* CHANGE PASSWORD CARD */}
//           <Card>
//             <TitleRow>
//               <IconWrap><FaLock /></IconWrap>
//               <SectionTitle>Change Password</SectionTitle>
//             </TitleRow>
//             <Subtitle>Ensure your account is using a strong, random password to stay secure.</Subtitle>

//             {passwordMsg.text && <Message type={passwordMsg.type} $isDarkMode={isDarkMode}>{passwordMsg.text}</Message>}

//             <Form onSubmit={handlePasswordSubmit}>
//               <FormGrid>
//                 <FormGroup>
//                   <Label>New Password</Label>
//                   <PasswordInputWrapper>
//                     <PasswordInput 
//                       type={showNewPassword ? "text" : "password"} 
//                       name="newPassword" 
//                       value={passwordData.newPassword} 
//                       onChange={handlePasswordChange} 
//                       placeholder=" Enter new password"
//                       required 
//                     />
//                     <EyeButton type="button" onClick={() => setShowNewPassword(!showNewPassword)}>
//                       {showNewPassword ? <FaEyeSlash /> : <FaEye />}
//                     </EyeButton>
//                   </PasswordInputWrapper>
//                 </FormGroup>
                
//                 <FormGroup>
//                   <Label>Confirm New Password</Label>
//                   <PasswordInputWrapper>
//                     <PasswordInput 
//                       type={showConfirmPassword ? "text" : "password"} 
//                       name="confirmPassword" 
//                       value={passwordData.confirmPassword} 
//                       onChange={handlePasswordChange} 
//                       placeholder="Confirm new password"
//                       required 
//                     />
//                     <EyeButton type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
//                       {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//                     </EyeButton>
//                   </PasswordInputWrapper>
//                 </FormGroup>
//               </FormGrid>

//               <FormActions>
//                 <Button type="submit" disabled={passwordLoading}>
//                   {passwordLoading ? "Updating..." : "Update Password"}
//                 </Button>
//               </FormActions>
//             </Form>
//           </Card>
//         </SettingsGrid>
//       </Main>
//       <Footer />
//     </Container>
//   );
// };

// export default Settings;









//           // {/* NOTIFICATION PREFERENCES CARD */}
//           // <Card>
//           //   <TitleRow>
//           //     <IconWrap><FaBell /></IconWrap>
//           //     <SectionTitle>Notification Preferences</SectionTitle>
//           //   </TitleRow>
//           //   <Subtitle>Control how and when you receive alerts from the platform.</Subtitle>

//           //   <FormGrid style={{ gridTemplateColumns: '1fr', gap: '12px' }}>
//           //     <ToggleLabel onClick={() => toggleNotification('emailAlerts')}>
//           //       <div>
//           //         <ToggleText>Goal Reminders</ToggleText>
//           //         <ToggleSubtext>Receive email alerts when weekly goals are approaching their deadline.</ToggleSubtext>
//           //       </div>
//           //       <Switch active={notifications.emailAlerts} />
//           //     </ToggleLabel>

//           //     <ToggleLabel onClick={() => toggleNotification('weeklyDigest')}>
//           //       <div>
//           //         <ToggleText>Weekly Summary Digest</ToggleText>
//           //         <ToggleSubtext>A summary of your team's performance and compliance sent every Friday.</ToggleSubtext>
//           //       </div>
//           //       <Switch active={notifications.weeklyDigest} />
//           //     </ToggleLabel>
//           //   </FormGrid>
//           // </Card>


// import React, { useState, useEffect } from "react";
// import styled from "styled-components";
// import { FaLock, FaUserEdit, FaBell, FaEye, FaEyeSlash, FaMoon, FaSun } from "react-icons/fa";
// import Navbar from "./Navbar";
// import DashboardHeader from "./DashboardHeader";
// import Footer from "./Footer";
// import api from "../api"; 
// import { useTheme } from '../App';

// /* ================= PAGE LAYOUT & THEME ================= */
// const Container = styled.div`
//   --sidebar-expanded: 260px;
//   --sidebar-collapsed: 90px;
  
//   /* Theme Variables */
//   --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
//   --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
//   --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
//   --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
//   --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
//   --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
//   --input-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e5e7eb'};
  
//   --primary: #2563eb;
//   --primary-dark: #1d4ed8;
//   --shadow-lg: 0 22px 55px rgba(0, 0, 0, 0.15);
//   --shadow-md: 0 12px 30px rgba(0, 0, 0, 0.1);

//   min-height: 100vh;
//   background: var(--page-bg);
//   color: var(--text-main);
//   margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
//   transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

//   @media (max-width: 1023px) { margin-left: 0; }
// `;

// const Main = styled.main`
//   width: min(1380px, calc(100% - 32px)); margin: 0 auto; padding: 94px 0 80px;
//   @media (max-width: 1023px) { width: min(100%, calc(100% - 24px)); padding-top: 86px; }
//   @media (max-width: 576px) { width: min(100%, calc(100% - 16px)); }
// `;

// /* ================= HERO ================= */
// const Hero = styled.section` margin-bottom: 24px; `;

// const HeroPanel = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 45%, #2563eb 100%); color: white;
//   padding: 32px 28px; border-radius: 20px; box-shadow: var(--shadow-lg); position: relative;
//   overflow: hidden; display: flex; flex-direction: column; justify-content: flex-start;

//   &::before {
//     content: ""; position: absolute; right: -30px; bottom: -60px; width: 180px; height: 180px;
//     border-radius: 50%; background: rgba(255, 255, 255, 0.08);
//   }
//   @media (max-width: 576px) { padding: 24px 18px; border-radius: 16px; }
// `;

// const HeroTitle = styled.h1` margin: 0; font-size: clamp(1.8rem, 1.5rem + 1.5vw, 2.5rem); line-height: 1.1; font-weight: 800; position: relative; z-index: 1; `;
// const HeroText = styled.p` margin: 16px 0 0; color: rgba(255, 255, 255, 0.82); line-height: 1.5; font-size: 0.95rem; max-width: 720px; position: relative; z-index: 1; `;

// /* ================= CARDS / FORMS ================= */
// const SettingsGrid = styled.div`
//   display: grid; grid-template-columns: 1fr; gap: 24px; max-width: 800px; 
// `;

// const Card = styled.div`
//   background: var(--card-bg); border-radius: 28px; padding: 30px; box-shadow: var(--shadow-md); border: 1px solid var(--border);
//   transition: background 0.3s ease, border 0.3s ease;
//   @media (max-width: 768px) { padding: 20px; border-radius: 22px; }
// `;

// const TitleRow = styled.div` display: flex; align-items: center; gap: 12px; margin-bottom: 8px; `;

// const IconWrap = styled.div` color: var(--primary); font-size: 1.4rem; display: flex; align-items: center; `;

// const SectionTitle = styled.h2` font-size: clamp(1.15rem, 1rem + 0.6vw, 1.35rem); color: var(--text-main); margin: 0; font-weight: 800; `;

// const Subtitle = styled.p` color: var(--text-soft); margin: 0 0 24px; font-size: 0.95rem; line-height: 1.6; `;

// const Form = styled.form` display: flex; flex-direction: column; gap: 20px; `;

// const FormGrid = styled.div` display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; @media (max-width: 768px) { grid-template-columns: 1fr; } `;

// const FormGroup = styled.div` display: flex; flex-direction: column; gap: 8px; `;
// const Label = styled.label` font-size: 14px; font-weight: 700; color: var(--text-main); `;

// const Input = styled.input`
//   width: 100%;
//   padding: 14px 16px; border-radius: 12px; border: 1px solid var(--input-border); 
//   font-size: 15px; background: var(--input-bg); color: var(--text-main);
//   transition: all 0.2s ease; box-sizing: border-box;
//   &:focus { border-color: #2563eb; box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12); outline: none; }
//   &:disabled { background: var(--border); color: var(--text-soft); cursor: not-allowed; }
// `;

// /* ===== PASSWORD INPUT WRAPPER ===== */
// const PasswordInputWrapper = styled.div` position: relative; display: flex; align-items: center; `;
// const PasswordInput = styled(Input)` padding-right: 48px; &::-ms-reveal, &::-ms-clear { display: none; } `;
// const EyeButton = styled.button` position: absolute; right: 14px; background: none; border: none; color: #94a3b8; font-size: 18px; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0; transition: color 0.2s ease; &:hover { color: #3b82f6; } `;

// const FormActions = styled.div` display: flex; justify-content: flex-end; margin-top: 10px; `;

// const Button = styled.button`
//   appearance: none; padding: 14px 24px; background: linear-gradient(135deg, #2563eb, #3b82f6); color: white;
//   border: none; border-radius: 12px; font-size: 15px; font-weight: 700; cursor: pointer; min-width: 140px;
//   box-shadow: 0 10px 20px rgba(37, 99, 235, 0.18); transition: transform 0.2s ease, box-shadow 0.2s ease;
//   &:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 14px 24px rgba(37, 99, 235, 0.24); }
//   &:disabled { background: linear-gradient(135deg, #93c5fd, #bfdbfe); cursor: not-allowed; box-shadow: none; }
// `;

// const Message = styled.div`
//   padding: 14px 18px; border-radius: 12px; margin-bottom: 20px; font-size: 14.5px; font-weight: 500;
//   ${({ type, $isDarkMode }) => {
//     if (type === "success") return $isDarkMode ? `background: rgba(16, 185, 129, 0.1); color: #34d399; border: 1px solid rgba(52, 211, 153, 0.3);` : `background: #ecfdf5; color: #10b981; border: 1px solid #a7f3d0;`;
//     return $isDarkMode ? `background: rgba(239, 68, 68, 0.1); color: #f87171; border: 1px solid rgba(248, 113, 113, 0.3);` : `background: #fef2f2; color: #ef4444; border: 1px solid #fecaca;`;
//   }}
// `;

// /* Toggle Switch Styles */
// const ToggleLabel = styled.label`
//   display: flex; align-items: center; justify-content: space-between; cursor: pointer;
//   padding: 16px; border: 1px solid var(--border); border-radius: 16px;
//   background: var(--input-bg); transition: background 0.2s;
//   &:hover { border-color: #94a3b8; }
// `;

// const ToggleInfo = styled.div` display: flex; align-items: center; gap: 14px; `;
// const ToggleIconWrap = styled.div` font-size: 1.4rem; color: ${({ active }) => active ? '#fbbf24' : '#64748b'}; display: flex; `;
// const ToggleTextWrap = styled.div` display: flex; flex-direction: column; `;
// const ToggleText = styled.div` font-size: 15px; font-weight: 700; color: var(--text-main); `;
// const ToggleSubtext = styled.div` font-size: 13px; font-weight: 400; color: var(--text-soft); margin-top: 2px; `;

// const Switch = styled.div`
//   position: relative; width: 48px; height: 26px; background: ${({ active }) => (active ? "#2563eb" : "#cbd5e1")};
//   border-radius: 999px; transition: background 0.3s ease; flex-shrink: 0;
//   &::after {
//     content: ""; position: absolute; top: 3px; left: ${({ active }) => (active ? "25px" : "3px")};
//     width: 20px; height: 20px; background: white; border-radius: 50%; transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//     box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//   }
// `;


// /* ================= COMPONENT ================= */
// const Settings = ({ user }) => {
//   const [collapsed, setCollapsed] = useState(false);
//   const { isDarkMode, toggleTheme } = useTheme();

//   // States for Profile Update
//   const [profileData, setProfileData] = useState({
//     username: user?.username || user?.name || "",
//     email: user?.email || "",
//   });
//   const [profileLoading, setProfileLoading] = useState(false);
//   const [profileMsg, setProfileMsg] = useState({ type: "", text: "" });

//   // 🔥 RESTORED CURRENT PASSWORD STATE 🔥
//   const [passwordData, setPasswordData] = useState({
//     currentPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//   });
//   const [passwordLoading, setPasswordLoading] = useState(false);
//   const [passwordMsg, setPasswordMsg] = useState({ type: "", text: "" });

//   const [showCurrentPassword, setShowCurrentPassword] = useState(false);
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

//   const handleProfileChange = (e) => {
//     setProfileData({ ...profileData, [e.target.name]: e.target.value });
//     setProfileMsg({ type: "", text: "" });
//   };

//   const handlePasswordChange = (e) => {
//     setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
//     setPasswordMsg({ type: "", text: "" });
//   };

//   const handleProfileSubmit = async (e) => {
//     e.preventDefault();
//     setProfileLoading(true);
//     try {
//       await api.put('/auth/profile', { email: profileData.email });
//       setProfileMsg({ type: "success", text: "Email updated successfully." });
//     } catch (err) {
//       setProfileMsg({ type: "error", text: err.response?.data?.message || "Failed to update profile." });
//     } finally {
//       setProfileLoading(false);
//     }
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     setPasswordLoading(true);

//     if (passwordData.newPassword !== passwordData.confirmPassword) {
//       setPasswordMsg({ type: "error", text: "New passwords do not match." });
//       setPasswordLoading(false);
//       return;
//     }

//     try {
//       // 🔥 NOW SENDING CURRENT PASSWORD TO SATISFY BACKEND 400 ERROR 🔥
//       await api.put('/auth/change-password', {
//         currentPassword: passwordData.currentPassword,
//         newPassword: passwordData.newPassword
//       });

//       setPasswordMsg({ type: "success", text: "Password changed successfully." });
//       setPasswordData({ currentPassword: "", newPassword: "", confirmPassword: "" });
//       setShowCurrentPassword(false);
//       setShowNewPassword(false);
//       setShowConfirmPassword(false);
//     } catch (err) {
//       setPasswordMsg({ type: "error", text: err.response?.data?.message || "Failed to change password." });
//     } finally {
//       setPasswordLoading(false);
//     }
//   };

//   return (
//     <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
//       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//       <DashboardHeader user={user} collapsed={collapsed} title="Settings" />

//       <Main>
//         <Hero>
//           <HeroPanel>
//             <HeroTitle>Settings</HeroTitle>
//             <HeroText>Manage your account preferences, profile details, and security.</HeroText>
//           </HeroPanel>
//         </Hero>

//         <SettingsGrid>
          
//           {/* THEME / PREFERENCES CARD */}
//           <Card>
//             <TitleRow>
//               <IconWrap><FaSun /></IconWrap>
//               <SectionTitle>Preferences</SectionTitle>
//             </TitleRow>
//             <Subtitle>Customize how the application looks for you.</Subtitle>

//             <ToggleLabel onClick={toggleTheme}>
//               <ToggleInfo>
//                 <ToggleIconWrap active={isDarkMode}>
//                   {isDarkMode ? <FaMoon /> : <FaSun />}
//                 </ToggleIconWrap>
//                 <ToggleTextWrap>
//                   <ToggleText>Dark Mode</ToggleText>
//                   <ToggleSubtext>Switch the interface to a darker color palette.</ToggleSubtext>
//                 </ToggleTextWrap>
//               </ToggleInfo>
//               <Switch active={isDarkMode} />
//             </ToggleLabel>
//           </Card>

//           {/* PROFILE INFORMATION CARD */}
//           <Card>
//             <TitleRow>
//               <IconWrap><FaUserEdit /></IconWrap>
//               <SectionTitle>Profile Information</SectionTitle>
//             </TitleRow>
//             <Subtitle>Update your account details and how you are recognized in the system.</Subtitle>
            
//             {profileMsg.text && <Message type={profileMsg.type} $isDarkMode={isDarkMode}>{profileMsg.text}</Message>}

//             <Form onSubmit={handleProfileSubmit}>
//               <FormGrid>
//                 <FormGroup>
//                   <Label>Username</Label>
//                   <Input 
//                     type="text" 
//                     name="username" 
//                     value={profileData.username} 
//                     disabled 
//                     title="Username cannot be changed"
//                   />
//                 </FormGroup>
//                 <FormGroup>
//                   <Label>Email Address</Label>
//                   <Input 
//                     type="email" 
//                     name="email" 
//                     value={profileData.email} 
//                     onChange={handleProfileChange} 
//                     required 
//                   />
//                 </FormGroup>
//               </FormGrid>

//               <FormActions>
//                 <Button type="submit" disabled={profileLoading}>
//                   {profileLoading ? "Saving..." : "Save Email"}
//                 </Button>
//               </FormActions>
//             </Form>
//           </Card>

//           {/* CHANGE PASSWORD CARD */}
//           <Card>
//             <TitleRow>
//               <IconWrap><FaLock /></IconWrap>
//               <SectionTitle>Change Password</SectionTitle>
//             </TitleRow>
//             <Subtitle>Ensure your account is using a strong, random password to stay secure.</Subtitle>

//             {passwordMsg.text && <Message type={passwordMsg.type} $isDarkMode={isDarkMode}>{passwordMsg.text}</Message>}

//             <Form onSubmit={handlePasswordSubmit}>
//               <FormGroup>
//                 <Label>Current Password</Label>
//                 <PasswordInputWrapper>
//                   <PasswordInput 
//                     type={showCurrentPassword ? "text" : "password"} 
//                     name="currentPassword" 
//                     value={passwordData.currentPassword} 
//                     onChange={handlePasswordChange} 
//                     placeholder="Enter your current password"
//                     required 
//                   />
//                   <EyeButton type="button" onClick={() => setShowCurrentPassword(!showCurrentPassword)}>
//                     {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
//                   </EyeButton>
//                 </PasswordInputWrapper>
//               </FormGroup>

//               <FormGrid>
//                 <FormGroup>
//                   <Label>New Password</Label>
//                   <PasswordInputWrapper>
//                     <PasswordInput 
//                       type={showNewPassword ? "text" : "password"} 
//                       name="newPassword" 
//                       value={passwordData.newPassword} 
//                       onChange={handlePasswordChange} 
//                       placeholder="Enter new password"
//                       required 
//                     />
//                     <EyeButton type="button" onClick={() => setShowNewPassword(!showNewPassword)}>
//                       {showNewPassword ? <FaEyeSlash /> : <FaEye />}
//                     </EyeButton>
//                   </PasswordInputWrapper>
//                 </FormGroup>
                
//                 <FormGroup>
//                   <Label>Confirm New Password</Label>
//                   <PasswordInputWrapper>
//                     <PasswordInput 
//                       type={showConfirmPassword ? "text" : "password"} 
//                       name="confirmPassword" 
//                       value={passwordData.confirmPassword} 
//                       onChange={handlePasswordChange} 
//                       placeholder="Confirm new password"
//                       required 
//                     />
//                     <EyeButton type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
//                       {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
//                     </EyeButton>
//                   </PasswordInputWrapper>
//                 </FormGroup>
//               </FormGrid>

//               <FormActions>
//                 <Button type="submit" disabled={passwordLoading}>
//                   {passwordLoading ? "Updating..." : "Update Password"}
//                 </Button>
//               </FormActions>
//             </Form>
//           </Card>
//         </SettingsGrid>
//       </Main>
//       <Footer />
//     </Container>
//   );
// };

// export default Settings;



import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FaLock, FaUserEdit, FaBell, FaEye, FaEyeSlash, FaMoon, FaSun } from "react-icons/fa";
import Navbar from "./Navbar";
import DashboardHeader from "./DashboardHeader";
import Footer from "./Footer";
import api from "../api"; 
import { useTheme } from '../App';

/* ================= PAGE LAYOUT & THEME ================= */
const Container = styled.div`
  --sidebar-expanded: 260px;
  --sidebar-collapsed: 90px;
  
  /* Theme Variables */
  --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
  --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.96)'};
  --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
  --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
  --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};
  --input-bg: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#ffffff'};
  --input-border: ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e5e7eb'};
  
  --primary: #2563eb;
  --primary-dark: #1d4ed8;
  --shadow-lg: 0 22px 55px rgba(0, 0, 0, 0.15);
  --shadow-md: 0 12px 30px rgba(0, 0, 0, 0.1);

  min-height: 100vh;
  background: var(--page-bg);
  color: var(--text-main);
  margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
  transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

  @media (max-width: 1023px) { margin-left: 0; }
`;

const Main = styled.main`
  width: min(1380px, calc(100% - 32px)); margin: 0 auto; padding: 14px 0 80px;
  @media (max-width: 1023px) { width: min(100%, calc(100% - 24px)); padding-top: 86px; }
  @media (max-width: 576px) { width: min(100%, calc(100% - 16px)); }
`;

/* ================= HERO ================= */
const Hero = styled.section` margin-bottom: 24px; `;

const HeroPanel = styled.div`
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 45%, #2563eb 100%); color: white;
  padding: 32px 28px; border-radius: 20px; box-shadow: var(--shadow-lg); position: relative;
  overflow: hidden; display: flex; flex-direction: column; justify-content: flex-start;

  &::before {
    content: ""; position: absolute; right: -30px; bottom: -60px; width: 180px; height: 180px;
    border-radius: 50%; background: rgba(255, 255, 255, 0.08);
  }
  @media (max-width: 576px) { padding: 24px 18px; border-radius: 16px; }
`;

const HeroTitle = styled.h1` margin: 0; font-size: clamp(1.8rem, 1.5rem + 1.5vw, 2.5rem); line-height: 1.1; font-weight: 800; position: relative; z-index: 1; `;
const HeroText = styled.p` margin: 16px 0 0; color: rgba(255, 255, 255, 0.82); line-height: 1.5; font-size: 0.95rem; max-width: 720px; position: relative; z-index: 1; `;

/* ================= CARDS / FORMS ================= */
const SettingsGrid = styled.div`
  display: grid; grid-template-columns: 1fr; gap: 24px; max-width: 800px; 
`;

const Card = styled.div`
  background: var(--card-bg); border-radius: 28px; padding: 30px; box-shadow: var(--shadow-md); border: 1px solid var(--border);
  transition: background 0.3s ease, border 0.3s ease;
  @media (max-width: 768px) { padding: 20px; border-radius: 22px; }
`;

const TitleRow = styled.div` display: flex; align-items: center; gap: 12px; margin-bottom: 8px; `;

const IconWrap = styled.div` color: var(--primary); font-size: 1.4rem; display: flex; align-items: center; `;

const SectionTitle = styled.h2` font-size: clamp(1.15rem, 1rem + 0.6vw, 1.35rem); color: var(--text-main); margin: 0; font-weight: 800; `;

const Subtitle = styled.p` color: var(--text-soft); margin: 0 0 24px; font-size: 0.95rem; line-height: 1.6; `;

const Form = styled.form` display: flex; flex-direction: column; gap: 20px; `;

const FormGrid = styled.div` display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; @media (max-width: 768px) { grid-template-columns: 1fr; } `;

const FormGroup = styled.div` display: flex; flex-direction: column; gap: 8px; `;
const Label = styled.label` font-size: 14px; font-weight: 700; color: var(--text-main); `;

const Input = styled.input`
  width: 100%;
  padding: 14px 16px; border-radius: 12px; border: 1px solid var(--input-border); 
  font-size: 15px; background: var(--input-bg); color: var(--text-main);
  transition: all 0.2s ease; box-sizing: border-box;
  &:focus { border-color: #2563eb; box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12); outline: none; }
  &:disabled { background: var(--border); color: var(--text-soft); cursor: not-allowed; }
`;

/* ===== PASSWORD INPUT WRAPPER ===== */
const PasswordInputWrapper = styled.div` position: relative; display: flex; align-items: center; `;
const PasswordInput = styled(Input)` padding-right: 48px; &::-ms-reveal, &::-ms-clear { display: none; } `;
const EyeButton = styled.button` position: absolute; right: 14px; background: none; border: none; color: #94a3b8; font-size: 18px; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0; transition: color 0.2s ease; &:hover { color: #3b82f6; } `;

const FormActions = styled.div` display: flex; justify-content: flex-end; margin-top: 10px; `;

const Button = styled.button`
  appearance: none; padding: 14px 24px; background: linear-gradient(135deg, #2563eb, #3b82f6); color: white;
  border: none; border-radius: 12px; font-size: 15px; font-weight: 700; cursor: pointer; min-width: 140px;
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.18); transition: transform 0.2s ease, box-shadow 0.2s ease;
  &:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 14px 24px rgba(37, 99, 235, 0.24); }
  &:disabled { background: linear-gradient(135deg, #93c5fd, #bfdbfe); cursor: not-allowed; box-shadow: none; }
`;

const Message = styled.div`
  padding: 14px 18px; border-radius: 12px; margin-bottom: 20px; font-size: 14.5px; font-weight: 500;
  ${({ type, $isDarkMode }) => {
    if (type === "success") return $isDarkMode ? `background: rgba(16, 185, 129, 0.1); color: #34d399; border: 1px solid rgba(52, 211, 153, 0.3);` : `background: #ecfdf5; color: #10b981; border: 1px solid #a7f3d0;`;
    return $isDarkMode ? `background: rgba(239, 68, 68, 0.1); color: #f87171; border: 1px solid rgba(248, 113, 113, 0.3);` : `background: #fef2f2; color: #ef4444; border: 1px solid #fecaca;`;
  }}
`;

/* Toggle Switch Styles */
const ToggleLabel = styled.label`
  display: flex; align-items: center; justify-content: space-between; cursor: pointer;
  padding: 16px; border: 1px solid var(--border); border-radius: 16px;
  background: var(--input-bg); transition: background 0.2s;
  &:hover { border-color: #94a3b8; }
`;

const ToggleInfo = styled.div` display: flex; align-items: center; gap: 14px; `;
const ToggleIconWrap = styled.div` font-size: 1.4rem; color: ${({ active }) => active ? '#fbbf24' : '#64748b'}; display: flex; `;
const ToggleTextWrap = styled.div` display: flex; flex-direction: column; `;
const ToggleText = styled.div` font-size: 15px; font-weight: 700; color: var(--text-main); `;
const ToggleSubtext = styled.div` font-size: 13px; font-weight: 400; color: var(--text-soft); margin-top: 2px; `;

const Switch = styled.div`
  position: relative; width: 48px; height: 26px; background: ${({ active }) => (active ? "#2563eb" : "#cbd5e1")};
  border-radius: 999px; transition: background 0.3s ease; flex-shrink: 0;
  &::after {
    content: ""; position: absolute; top: 3px; left: ${({ active }) => (active ? "25px" : "3px")};
    width: 20px; height: 20px; background: white; border-radius: 50%; transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
`;

/* ================= COMPONENT ================= */
// 🔥 WE NOW ACCEPT `setUser` FROM APP.JS SO WE CAN UPDATE THE GLOBAL STATE 🔥
const Settings = ({ user, setUser }) => {
  const [collapsed, setCollapsed] = useState(false);
  const { isDarkMode, toggleTheme } = useTheme();

  // States for Profile Update
  const [profileData, setProfileData] = useState({
    username: user?.username || user?.name || "",
    email: user?.email || "",
  });
  const [profileLoading, setProfileLoading] = useState(false);
  const [profileMsg, setProfileMsg] = useState({ type: "", text: "" });

  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [passwordMsg, setPasswordMsg] = useState({ type: "", text: "" });

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleProfileChange = (e) => {
    setProfileData({ ...profileData, [e.target.name]: e.target.value });
    setProfileMsg({ type: "", text: "" });
  };

  const handlePasswordChange = (e) => {
    setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
    setPasswordMsg({ type: "", text: "" });
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setProfileLoading(true);
    try {
      const res = await api.put('/auth/profile', { email: profileData.email });
      
      if (res.data.success) {
        // 🔥 2. IMMEDIATELY FETCH THE UPDATED DATA 🔥
        try {
          const fetchRes = await api.get("/auth/profile");
          
          if (fetchRes.data.success && fetchRes.data.user) {
            const latestUser = fetchRes.data.user;

            // Update localStorage globally
            localStorage.setItem("user", JSON.stringify(latestUser));

            // Update the global App.js React State (This instantly updates the Navbar/Sidebar)
            if (setUser) {
              setUser(latestUser);
            }
          }
        } catch (fetchErr) {
          console.error("Updated successfully, but failed to fetch fresh data", fetchErr);
        }
        
        setProfileMsg({ type: "success", text: "Email updated successfully." });
      }
    } catch (err) {
      setProfileMsg({ type: "error", text: err.response?.data?.message || "Failed to update profile." });
    } finally {
      setProfileLoading(false);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPasswordLoading(true);

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setPasswordMsg({ type: "error", text: "New passwords do not match." });
      setPasswordLoading(false);
      return;
    }

    try {
      await api.put('/auth/change-password', {
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword
      });

      setPasswordMsg({ type: "success", text: "Password changed successfully." });
      setPasswordData({ currentPassword: "", newPassword: "", confirmPassword: "" });
      setShowCurrentPassword(false);
      setShowNewPassword(false);
      setShowConfirmPassword(false);
    } catch (err) {
      setPasswordMsg({ type: "error", text: err.response?.data?.message || "Failed to change password." });
    } finally {
      setPasswordLoading(false);
    }
  };

  return (
    <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
      <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
      {/* <DashboardHeader user={user} collapsed={collapsed} title="Settings" /> */}

      <Main>
        <Hero>
          <HeroPanel>
            <HeroTitle>Settings</HeroTitle>
            <HeroText>Manage your account preferences, profile details, and security.</HeroText>
          </HeroPanel>
        </Hero>

        <SettingsGrid>
          
          {/* THEME / PREFERENCES CARD */}
          <Card>
            <TitleRow>
              <IconWrap><FaSun /></IconWrap>
              <SectionTitle>Preferences</SectionTitle>
            </TitleRow>
            <Subtitle>Customize how the application looks for you.</Subtitle>

            <ToggleLabel onClick={toggleTheme}>
              <ToggleInfo>
                <ToggleIconWrap active={isDarkMode}>
                  {isDarkMode ? <FaMoon /> : <FaSun />}
                </ToggleIconWrap>
                <ToggleTextWrap>
                  <ToggleText>Dark Mode</ToggleText>
                  <ToggleSubtext>Switch the interface to a darker color palette.</ToggleSubtext>
                </ToggleTextWrap>
              </ToggleInfo>
              <Switch active={isDarkMode} />
            </ToggleLabel>
          </Card>

          {/* PROFILE INFORMATION CARD */}
          <Card>
            <TitleRow>
              <IconWrap><FaUserEdit /></IconWrap>
              <SectionTitle>Profile Information</SectionTitle>
            </TitleRow>
            <Subtitle>Update your account details and how you are recognized in the system.</Subtitle>
            
            {profileMsg.text && <Message type={profileMsg.type} $isDarkMode={isDarkMode}>{profileMsg.text}</Message>}

            <Form onSubmit={handleProfileSubmit}>
              <FormGrid>
                <FormGroup>
                  <Label>Username</Label>
                  <Input 
                    type="text" 
                    name="username" 
                    value={profileData.username} 
                    disabled 
                    title="Username cannot be changed"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Email Address</Label>
                  <Input 
                    type="email" 
                    name="email" 
                    value={profileData.email} 
                    onChange={handleProfileChange} 
                    required 
                  />
                </FormGroup>
              </FormGrid>

              <FormActions>
                <Button type="submit" disabled={profileLoading}>
                  {profileLoading ? "Saving..." : "Save Email"}
                </Button>
              </FormActions>
            </Form>
          </Card>

          {/* CHANGE PASSWORD CARD */}
{/*           
          <Card>
            <TitleRow>
              <IconWrap><FaLock /></IconWrap>
              <SectionTitle>Change Password</SectionTitle>
            </TitleRow>
            <Subtitle>Ensure your account is using a strong, random password to stay secure.</Subtitle>

            {passwordMsg.text && <Message type={passwordMsg.type} $isDarkMode={isDarkMode}>{passwordMsg.text}</Message>}

            <Form onSubmit={handlePasswordSubmit}>
              <FormGroup>
                <Label>Current Password</Label>
                <PasswordInputWrapper>
                  <PasswordInput 
                    type={showCurrentPassword ? "text" : "password"} 
                    name="currentPassword" 
                    value={passwordData.currentPassword} 
                    onChange={handlePasswordChange} 
                    placeholder="Enter your current password"
                    required 
                  />
                  <EyeButton type="button" onClick={() => setShowCurrentPassword(!showCurrentPassword)}>
                    {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                  </EyeButton>
                </PasswordInputWrapper>
              </FormGroup>

              <FormGrid>
                <FormGroup>
                  <Label>New Password</Label>
                  <PasswordInputWrapper>
                    <PasswordInput 
                      type={showNewPassword ? "text" : "password"} 
                      name="newPassword" 
                      value={passwordData.newPassword} 
                      onChange={handlePasswordChange} 
                      placeholder="Enter new password"
                      required 
                    />
                    <EyeButton type="button" onClick={() => setShowNewPassword(!showNewPassword)}>
                      {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                    </EyeButton>
                  </PasswordInputWrapper>
                </FormGroup>
                
                <FormGroup>
                  <Label>Confirm New Password</Label>
                  <PasswordInputWrapper>
                    <PasswordInput 
                      type={showConfirmPassword ? "text" : "password"} 
                      name="confirmPassword" 
                      value={passwordData.confirmPassword} 
                      onChange={handlePasswordChange} 
                      placeholder="Confirm new password"
                      required 
                    />
                    <EyeButton type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                      {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </EyeButton>
                  </PasswordInputWrapper>
                </FormGroup>
              </FormGrid>

              <FormActions>
                <Button type="submit" disabled={passwordLoading}>
                  {passwordLoading ? "Updating..." : "Update Password"}
                </Button>
              </FormActions>
            </Form>
          </Card> */}
        </SettingsGrid>
      </Main>
      <Footer />
    </Container>
  );
};

export default Settings;